import {
  AllocationPayload,
  CreateMiqaatPayload,
  CreateRotationPayload,
  miqaatConfigFilters,
  TourOperatorApi,
  UpdateMiqaatPayload,
  UpdateRotationPayload,
} from "types/miqaatConfig";
import axiosInstance from "./axiosInstance";

// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getLawazimTypesList = async () => {
  // const res = await axiosInstance.get("/lawazim-config", {
  const res = await axiosInstance.get("/Lawazim?isMiqaat=true", {
    headers: getAuthHeader(),
  });
  return res.data?.data;
};

export const getMiqaatStatics = async () => {
  const res = await axiosInstance.get("/miqaat/stats", {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const getTourOperatorsForMiqaat = async (): Promise<
  TourOperatorApi[]
> => {
  const res = await axiosInstance.get("/tour-operator", {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const getMiqaatConfigList = async (
  filters: miqaatConfigFilters = {},
) => {
  try {
    const response = await axiosInstance.get("/miqaat/list", {
      params: {
        pageNo: filters.pageNo ?? 0,
        pageSize: filters.pageSize ?? 20,
        searchText: filters.searchTerm || undefined,
        miqaatName: filters.miqaatName || undefined,
        miqaatCode: filters.miqaatCode || undefined,
        rotationName: filters.rotationName || undefined,
        rotationCode: filters.rotationCode || undefined,
        requireRaza: filters.razaPackage || undefined,
      },
      headers: {
        ...getAuthHeader(),
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createMiqaatConfig = async (payload: CreateMiqaatPayload) => {
  try {
    const response = await axiosInstance.post("/miqaat", payload, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteMiqaatConfig = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/miqaat/${id}`, {
    headers: {
      ...getAuthHeader(),
    },
  });
};

export const getMiqaatByPublicId = async (publicId: string) => {
  try {
    const response = await axiosInstance.get(`/miqaat/${publicId}/full`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const updateMiqaat = async (payload: UpdateMiqaatPayload) => {
  try {
    const response = await axiosInstance.put(
      "/miqaat",
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const createRotation = async (payload: CreateRotationPayload) => {
  try {
    const response = await axiosInstance.post(
      "/miqaat-rotation/create-only",
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const updateRotation = async (payload: UpdateRotationPayload) => {
  try {
    const response = await axiosInstance.put(
      "/miqaat-rotation/update",
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const createUpdateQuota = async (payload: AllocationPayload) => {
  try {
    const response = await axiosInstance.post(
      "/miqaat-rotation/assign-allocations",
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
